import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Portfolio from "./pages/Portfolio";
import ClientSummary from "./pages/ClientSummary";
import PayrollChecklist from "./pages/PayrollChecklist";
import PayrollDashboard from "./pages/PayrollDashboard";
import PYResults from "./pages/PYResults";
import RunDetail from "./pages/RunDetail";
import ErrorDetail from "./pages/ErrorDetail";
import EmployeeDetail from "./pages/EmployeeDetail";
import FindingDetail from "./pages/FindingDetail";
import AuditTrail from "./pages/AuditTrail";
import Worklist from "./pages/Worklist";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
            <Route path="/worklist" element={<ProtectedRoute><Worklist /></ProtectedRoute>} />
            <Route path="/clients/:clientId" element={<Navigate to="checklist" replace />} />
            <Route path="/clients/:clientId/checklist" element={<ProtectedRoute><PayrollChecklist /></ProtectedRoute>} />
            <Route path="/clients/:clientId/dashboard" element={<ProtectedRoute><PayrollDashboard /></ProtectedRoute>} />
            <Route path="/clients/:clientId/py-results" element={<ProtectedRoute><PYResults /></ProtectedRoute>} />
            <Route path="/clients/:clientId/compare" element={<ProtectedRoute><ClientSummary /></ProtectedRoute>} />
            <Route path="/clients/:clientId/audit" element={<ProtectedRoute><AuditTrail /></ProtectedRoute>} />
            <Route path="/runs/:runId" element={<ProtectedRoute><RunDetail /></ProtectedRoute>} />
            <Route path="/runs/:runId/errors" element={<ProtectedRoute><ErrorDetail /></ProtectedRoute>} />
            <Route path="/runs/:runId/employees/:employeeId" element={<ProtectedRoute><EmployeeDetail /></ProtectedRoute>} />
            <Route path="/findings/:findingId" element={<ProtectedRoute><FindingDetail /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
